////////LIBRARY/////////
import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { cloneDeep, isEqual, isNull, isUndefined } from 'lodash'
import moment from 'moment'
///////COMPONENTS///////
import Modals from '../../../components/Modals'
import theme from '../../../theme/theme'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import Table from '../../../components/Table'
import { PageTitle, PageWrapperActions, PageWrapperActionValidate, InputLogin, ErrorInputMsg } from '../../../theme/GlobalCss'
import ImgButton from '../../../components/Ui/ImgButton'
import UseDatePicker from '../../../hooks/UseDatePicker'
import { campaignPriceActionCreators } from '../../../store/actions'
import PriceCampaignUpdateSecondLine from './PriceCampaignUpdateSecondLine'
/////////ASSETS/////////
import CloseButtonIcon from '../../../assets/icones/global/close-white.svg'
import Calendar from '../../../assets/icones/global/calendar.svg'

//////STYLED//////
const PriceCampaignWrapper = styled.div`
	position: relative;
`
const PriceCampaignHeader = styled.div`
	display: flex;
	& > :first-child {
		margin: 0px auto 0px 0px;
		line-height: 32px;
	}
	& > * {
		top: 0px !important;
		line-height: 32px;
	}
	& > :last-child {
		margin-left: 25px;
	}
	height: 32px;
	margin-bottom: 15px;
`
const PriceCampaignActions = styled.div`
	position: relative;
	border-left: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	border-right: 1px solid ${(props) => props.theme.colors.dropdownDefault};
`
const PriceCampaignFilters = styled.div`
	position: relative;
	padding-right: 17px;
	& > * {
		margin: 0px 7px;
	}
	& > :first-child img {
		max-height: 24px;
		margin: 0px 10px 0px 0px;
	}
	display: flex;
	flex-direction: row;
`
const PriceCampaignContent = styled.div`
	overflow: auto;
	padding: 0px 30px;
	background-color: #f1f1f1;
`
const PriceCampaignInputs = styled.div`
	display: flex;
	& > * {
		margin: 0px 7px;
	}
`
const PriceCampaignInputDate = styled.div`
	display: flex;
	& p {
		margin: 0;
	}
`
const PriceCampaignInputName = styled.div`
	display: flex;
	& p {
		margin: 0px 15px 0px 0px;
	}
`
const DatePickerCampaignIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	margin: 0px 8px 0px 15px;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
//////STYLED//////

const PriceCampaignUpdateHandler = (props) => {
	const [stateDefaultValues, setStateDefaultValues] = useState({
		campaignName: '',
	})

	const priceCampaignActions = bindActionCreators(campaignPriceActionCreators, useDispatch())

	const { translations, campaignIsSend } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			campaignIsSend: state.campaignPrice.update,
		}),
		shallowEqual
	)

	const [priceItemLines, setPriceItemLines] = useState([])

	const { register, handleSubmit, errors, setValue, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	const [dateCampaignOpenDateModalHandler, dateCampaignRenderModal, dateCampaignStateDate, setStartDate] = UseDatePicker({
		defaultDateStart: props.data?.dateStart ? moment(props.data.dateStart).toDate() : moment().toDate(),
		noInterval: true,
		noPastDate: true,
		ifCancel: true,
		insideModal: true,
	})

	const currency = props.data.currency.symbol

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const [titleFocusIn, setTitleFocusIn] = useState()
	const [titleFocusOut, setTitleFocusOut] = useState()
	const [countFocusIn, setCountFocusIn] = useState(0)
	const [countFocusOut, setCountFocusOut] = useState(0)
	const [isFocused, setIsFocused] = useState(false)
	const onSubmit = (data) => {
		// We have to test our counter to send the correct title
		let datas = cloneDeep(data)
		datas.dateStart = moment(dateCampaignStateDate.date.startDate).toDate()
		if (props.updateMode) {
			if (countFocusIn === 0) {
				datas.campaignName = titleFocusIn
				datas.widthTaxes = props.data.widthTaxes
				priceCampaignActions.updateCampaign(props.data.id, datas)
				// Campaign reset => was updated => so we can close modal
				if (campaignIsSend) props.closeModalHandler()
			} else if (countFocusOut > 0) {
				datas.campaignName = titleFocusOut
				datas.widthTaxes = props.data.widthTaxes
				priceCampaignActions.updateCampaign(props.data.id, datas)
				// Campaign reset => was updated => so we can close modal
				if (campaignIsSend) props.closeModalHandler()
			} else {
				datas.widthTaxes = props.data.widthTaxes
				priceCampaignActions.updateCampaign(props.data.id, datas)
				// Campaign reset => was updated => so we can close modal
				if (campaignIsSend) props.closeModalHandler()
			}
		}
	}

	// if we detect focus on input we increment a counter and set titleFocusIn
	// from the second focus in we have to use titleFocusOUt
	const handleFocusIn = () => {
		const countCp = cloneDeep(countFocusIn)
		setCountFocusIn(countCp + 1)
		if (!isUndefined(titleFocusOut) && !isEqual(titleFocusOut, titleFocusIn)) {
			setValue('campaignName', titleFocusOut)
		} else {
			setValue('campaignName', titleFocusIn)
		}
		setIsFocused(true)
	}

	//in case of focusOut we set a boolean to false and a focusOut Title
	const handleDetectFocusOut = (e) => {
		const countFocusOutCp = cloneDeep(countFocusOut)
		setCountFocusOut(countFocusOutCp + 1)
		setTitleFocusOut(e.target.value)
		setIsFocused(false)
	}

	const handleCloseModal = () => {
		props.closeModalHandler()
		setCountFocusIn(0)
		setCountFocusOut(0)
		setTitleFocusOut()
	}

	const handleTruncateString = (str, num) => {
		// If the length of str is less than or equal to num
		// just return str--don't truncate it.
		if (str.length <= num) {
			return str
		}
		// Return str truncated with '...' concatenated to the end of str.
		return str.slice(0, num) + '...'
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const columns = [
		{ titleColumnCampaign: true, callErrors: props.errors, currency: currency, component: () => <div>Valeurs actuelles</div> },
		{ dataHook: 'kioskCode', headerName: translations['page__promotionManagement__tableHeader_expand_kioskCode'], sortable: true },
		{ dataHook: 'store', headerName: translations['page__promotionManagement__tableHeader_expand_store'], sortable: true },
		{
			dataHook: 'itemFamily.translationKey',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_family'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemBrand.label',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_brand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'label',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_product'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: props.widthTaxes ? 'actualStandardPriceTTC' : 'actualStandardPriceHT',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemPrice'],
			sortable: true,
			isAuthorize: true,
			component: (props) => `${props.row[props.column.dataHook]}${currency}`,
		},
		// Conversion price => back always return TTC price so we must convert it
		{
			dataHook: props.widthTaxes ? 'actualStandardPriceHT' : 'actualStandardPriceTTC',
			headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_convert'],
			sortable: true,
			isAuthorize: true,
			component: (props) => `${props.row[props.column.dataHook]}${currency}`,
		},
		{
			dataHook: 'standardPriceVATRate',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemVAT'],
			sortable: true,
			isAuthorize: true,
			component: (props) => `${props.row.standardPriceVATRate}%`,
		},
		{
			dataHook: props.widthTaxes ? 'actualDepositPriceTTC' : 'actualDepositPriceHT',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositPrice'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (isNull(props.row[props.column.dataHook]) ? `0,00${currency}` : `${props.row[props.column.dataHook]}${currency}`),
		},
		{
			dataHook: 'depositPriceVATRate',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositVAT'],
			sortable: true,
			isAuthorize: true,
			component: (props) => `${props.row.depositPriceVATRate}%`,
		},
	]

	const config = {
		name: '',
		fixedColumnSelection: true,
		isCampaign: true,
		campaignValues: {
			campaignComponent: PriceCampaignUpdateSecondLine,
		},
		noWindowing: true,
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// Every time props data change, we set a new name and date
	useEffect(() => {
		setStartDate(moment(props.data.dateStart).toDate())
		if (props.data?.label?.length > 0) {
			// on data load we set the campaign name
			setTitleFocusIn(props.data.label)
			setValue('campaignName', handleTruncateString(props.data.label, 25))
			setStateDefaultValues(getValues())
		}
	}, [props.data])

	useEffect(() => {
		document.getElementById('input').click()
		setPriceItemLines(props.data.priceCampaignLines)
		return () => {
			props.closeModalHandler()
		}
	}, [])

	// to split the string we need to apply a test with boolean
	useEffect(() => {
		if (!isUndefined(titleFocusOut) && !isFocused) {
			setValue('campaignName', handleTruncateString(titleFocusOut, 25))
		}
	}, [titleFocusOut, isFocused])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Modals closeModalHandler={handleCloseModal} showModal={props.showModal} minWidth={1200}>
			{dateCampaignRenderModal()}
			<PriceCampaignWrapper>
				<form onSubmit={handleSubmit(onSubmit)}>
					<PriceCampaignHeader>
						<PriceCampaignInputs>
							<PriceCampaignInputDate>
								<PageTitle>{translations['modal__pricesManagement__pricesCampaign_creation_date']}</PageTitle>
								<DatePickerCampaignIcon onClick={dateCampaignOpenDateModalHandler} />
								<span>
									{isEqual(dateCampaignStateDate.date.startDate, {})
										? moment(new Date()).format('DD/MM/YYYY HH:mm')
										: moment(dateCampaignStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
								</span>
							</PriceCampaignInputDate>
							<PriceCampaignInputName>
								<PageTitle>{translations['modal__pricesManagement__pricesCampaign_creation_name']}</PageTitle>
								<InputLogin
									id="input"
									name="campaignName"
									type="text"
									onFocus={() => handleFocusIn()}
									onBlur={(e) => handleDetectFocusOut(e)}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: '',
										},
									})}
								/>
								{errors.campaignName && <ErrorInputMsg>{errors.campaignName.message}</ErrorInputMsg>}
							</PriceCampaignInputName>
						</PriceCampaignInputs>

						<PriceCampaignFilters>
							<ToggleFilters
								checked={true}
								name="withTTC"
								size={'large'}
								disabled
								labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
								labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
							/>
						</PriceCampaignFilters>

						<PageWrapperActions>
							<PageWrapperActionValidate unlocked onClick={() => handleSubmit(onSubmit)} />
							<ImgButton
								img={CloseButtonIcon}
								action={() => handleCloseModal()}
								color={theme.colors.error}
								margin={'5px'}
								hover={theme.colors.hoverError}
							/>
						</PageWrapperActions>
					</PriceCampaignHeader>
					<PriceCampaignContent>
						{translations && <Table inputColumns={columns} inputData={priceItemLines} inputConfig={config} />}
					</PriceCampaignContent>
				</form>
			</PriceCampaignWrapper>
		</Modals>
	)
}

PriceCampaignUpdateHandler.propTypes = {}
PriceCampaignUpdateHandler.defaultPropTypes = {}

export default PriceCampaignUpdateHandler
